/**
* @Description 文件功能说明：车辆组件
* @Author
* @Time 2021/6/4
**/
<template>
    <div class="view-tree-table">
        <!-- router-title-box start -->
        <div class="router-title-box" >
          <div class="router-title-item">
            <a href="javascript:void(0);" class="router-title-back cursor-pointer" @click="closeRouter" title="返回首页"></a>
            <div class="router-title-tit">
              <el-tabs class="whole-page-tabs" v-model="activeName" @tab-click="handleClick" tab-position="top">
                <el-tab-pane label="工时考勤" name="first" clor="red"></el-tab-pane>
                <el-tab-pane label="工时统计" name="second"></el-tab-pane>
              </el-tabs>
            </div>
          </div>
        </div>
        <!-- router-title-box end -->
        <ApproachAttendance v-show="activeName == 'first'" ref="approachAttendance" :userTypes="userTypes"/>
        <ApproachStatistics v-show="activeName == 'second'" ref="approachStatistics" :userTypes="userTypes"/>
    </div>
</template>

<script>
  import ApproachAttendance from "../../../components_pages/Approach/ApproachAttendance";
  import ApproachStatistics from "../../../components_pages/Approach/ApproachStatistics";
  import ApiUser from "../../../request/api-user";

	export default {
	    /*
	     * 组件名
	     */
	    name: "ApproachR",
	    /**
	     * 引用组件
	     * */
	    components: {
        ApproachAttendance,
        ApproachStatistics,
	    },
	    /**
	     * 数据定义
	     * */
	    data(){
	        return {
            activeName: 'first',
            userTypes: [],
	            // mini max tree box
	        }
	    },
	    /**
	     * 方法定义
	     */
	    methods:{
	        /**
	         * @Des 关闭路由
	         * @Auth
	         * @Date
	         */
	        closeRouter () {
	            // 跳转到 首页
	            this.$router.replace({path: this.$store.state.homePage}, ()=>{}, ()=>{});
	        },// closeRouter

        // 查询用户组
        searchUserGroup() {
          this.$request.postJsonRequest(ApiUser.searchUserGroupApi,{
            projectId: this.$store.state.currentProjectId
          }).then(result => {
            this.userTypes = [];
            if(result.code == 0){
              result.data.forEach((row, index) => {
                if(row.type == 1){
                  this.userTypes.push(row);
                }
              })
            }
            // console.log(this.userTypes);
          }).catch(error => {
            console.error('查询用户组异常', ApiUser.searchUserGroupApi, error);
          })
        },

        handleClick(tab, event) {
          if (tab.index == 0) {
            // 请求1
          } else if (tab.index == 1) {
            // 请求2
          }
        },// handleClick
	        
	    },// methods
	    /**
	     * 初始化加载
	     */
	    mounted() {
	    	this.searchUserGroup();
	    },
	    
	}// export default
</script>

/* CSS */
<style lang="scss" scoped>

</style>



// WEBPACK FOOTER //
// src/views/system-manager/approach/ApproachR.vue